<div *ngIf="deal.Id">
    <div class="">
        <div class="p-grid">
            <div class="p-col-12">
                <div class="page-header">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-8 p-md-8 p-sm-8">
                            <div *ngIf="deal.PropertyCity" style="font-size: 15px;color: #9B9B9B">{{deal.PropertyCity}}, {{deal.StatesName}}</div>
                            <div>{{deal.Title}}</div>
                        </div>
                        <div class="p-col-12 p-lg-4 p-md-4 p-sm-3">
                            <div class="floatRight">Deal # {{deal.Id}}</div>
                            <div class="floatRight" style="font-size: 15px;color: #9B9B9B">{{getAcceptCount()}} of 3 accepted</div>
                        </div>
                    </div>                   
                </div>
            </div>        
            <div class="p-col-12">
                <div class="divider-header">
                    <p-divider></p-divider>
                </div>
            </div>                       
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-12 p-lg-3 p-md-3 p-sm-4" *ngIf="isEditable">
                        <button pButton type="button" class="fullwidthbtn" label="Additional Communications" routerLink="/deal/additionalcommunication/{{deal.Id}}"></button>
                    </div>
                    <div class="p-col-12 p-lg-1 p-md-1 p-sm-2" *ngIf="isEditable">
                        <button pButton type="button" class="fullwidthbtn" label="Notes" routerLink="/deal/note/{{deal.Id}}"></button>
                    </div>
                    <div class="p-col-12 p-lg-1 p-md-1 p-sm-2" *ngIf="isEditable">
                        <button pButton type="button" class="fullwidthbtn" label="Edit" routerLink="/deal/edit/{{deal.Id}}"></button>
                    </div>
                </div>                
            </div>
        </div>    
    <p-accordion [multiple]="true">
        <p-accordionTab header="Deal Progress" [selected]="true" >
            <div class="p-grid">
                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="showAccept()">
                    <button pButton type="button" class="fullwidthbtn" label="Accept" (click)="acceptDeal()"></button>
                </div>
                <div class="p-col-12 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item">
                        <div class="p-col-12" [ngStyle]="{'color': (deal.DealStatusID == 1) ? '#1d6498' : (deal.DealStatusID == 2) ? '#d48127' : (deal.DealStatusID == 3) ? '#0ca325' : ''}"><strong>Status: </strong>{{dealStatuses[deal.DealStatusID]}}</div>
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <div class="p-col-12">
                            <div class="p-grid" style="margin-bottom:-1.2rem;">
                                <div class="p-col-12 p-lg-3 p-md-3 p-sm-3">
                                    <strong>Proposing Broker:</strong>
                                </div>
                                <div class="p-col-12 p-lg-7 p-md-7 p-sm-7">
                                    <p-button label=" {{deal.ProposingBrokerName}}" styleClass="p-button-link" (click)="navToUserProfile(deal.ProposingUserID)"></p-button>
                                    at
                                    <p-button label=" {{deal.ProposingMemberName}}" styleClass="p-button-link" routerLink="/member/{{deal.ProposingMemberID}}"></p-button>
                                </div>
                                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                                    <div class="p-col-12" *ngIf="deal.DealStatusID<2">
                                        <div class="floatRight">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #9B9B9B; margin-right:20px;" pTooltip="Deal is not proposed."> </i>
                                        </div>
                                    </div>
                                    <div class="p-col-12">
                                        <div class="floatRight" *ngIf="deal.DealStatusID>=2">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #0ca325; margin-right:20px;" pTooltip="Deal is proposed."> </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <div class="p-col-12">
                            <div class="p-grid" style="margin-bottom:-1.2rem;">
                                <div class="p-col-12 p-lg-3 p-md-3 p-sm-3">
                                    <strong>Proposing Business Director:</strong>
                                </div>
                                <div class="p-col-12 p-lg-7 p-md-7 p-sm-7">
                                    <p-button label=" {{deal.ProposingManagerName}}" styleClass="p-button-link" (click)="navToUserProfile(deal.ProposingManagerID)"></p-button>
                                    at
                                    <p-button label=" {{deal.ProposingMemberName}}" styleClass="p-button-link" routerLink="/member/{{deal.ProposingMemberID}}"></p-button>
                                </div>
                                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                                    <div class="p-col-12" *ngIf="!deal.ProposingAcceptDeal">
                                        <div class="floatRight">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #9B9B9B; margin-right:20px;"> </i>
                                        </div>
                                        <div *ngIf="isAdmin&&!isProposingDirector" style="margin-top: 15px;">
                                            <button pButton type="button" class="fullwidthbtn" label="Admin Accept" (click)="adminAccept(1)"></button>
                                        </div>
                                    </div>
                                    <div class="p-col-12">
                                        <div class="floatRight" *ngIf="deal.ProposingAcceptDeal">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #0ca325; margin-right:20px;"> </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <div class="p-col-12">
                            <div class="p-grid" style="margin-bottom:-1.2rem;">
                                <div class="p-col-12 p-lg-3 p-md-3 p-sm-3">
                                    <strong>Receiving Broker:</strong>
                                </div>
                                <div class="p-col-12 p-lg-7 p-md-7 p-sm-7">
                                    <p-button label=" {{deal.ReceivingBrokerName}}" styleClass="p-button-link" (click)="navToUserProfile(deal.ReceivingUserID)"></p-button>
                                    <span *ngIf="deal.ReceivingMemberName">
                                        at
                                        <p-button label=" {{deal.ReceivingMemberName}}" styleClass="p-button-link" routerLink="/member/{{deal.ReceivingMemberID}}"></p-button>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                                    <div class="p-col-12" *ngIf="!deal.ReceivingBrokerAccept">
                                        <div class="floatRight">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #9B9B9B; margin-right:20px;"> </i>
                                        </div>
                                        <div *ngIf="isAdmin&&!isRecipient" style="margin-top: 15px;">
                                            <button pButton type="button" class="fullwidthbtn" label="Admin Accept" (click)="adminAccept(2)"></button>
                                        </div>
                                    </div>
                                    <div class="p-col-12">
                                        <div class="floatRight" *ngIf="deal.ReceivingBrokerAccept">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #0ca325; margin-right:20px;"> </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <div class="p-col-12">
                            <div class="p-grid" style="margin-bottom:-1.2rem;">
                                <div class="p-col-12 p-lg-3 p-md-3 p-sm-3">
                                    <strong>Receiving Business Director:</strong>
                                </div>
                                <div class="p-col-12 p-lg-7 p-md-7 p-sm-7">
                                    <p-button label=" {{deal.ReceivingManagerName}}" styleClass="p-button-link" (click)="navToUserProfile(deal.ReceivingManagerID)"></p-button>
                                    <span *ngIf="deal.ReceivingMemberName">
                                        at
                                        <p-button label=" {{deal.ReceivingMemberName}}" styleClass="p-button-link" routerLink="/member/{{deal.ReceivingMemberID}}"></p-button>
                                    </span>
                                </div>
                                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                                    <div class="p-col-12" *ngIf="!deal.ReceivingAcceptDeal">
                                        <div class="floatRight">
                                            <i class="pi pi-check-circle" style="font-size: 21px; color: #9B9B9B; margin-right:20px;"> </i>
                                        </div>
                                        <div *ngIf="isAdmin&&!isReceivingDirector" style="margin-top: 15px;">
                                            <button pButton type="button" class="fullwidthbtn" label="Admin Accept" (click)="adminAccept(3)"></button>
                                        </div>
                                    </div>
                                    <div class="p-col-12">
                                        <div class="floatRight" *ngIf="deal.ReceivingAcceptDeal">
                                            <i class="pi pi-check-circle" style="font-size: 21px;color: #0ca325;margin-right: 20px;"> </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab header="Deal Information" [selected]="true">
            <div class="p-grid">

                <div class="p-col-12 p-lg-6 p-md-6 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item">
                        <strong>Type: </strong>{{deal.TypeName}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Value High: </strong>{{deal.ValueHigh? '$' : ''}}{{deal.ValueHigh}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Estimated Deal Value: </strong>{{deal.EstimatedDealValue? '$' : ''}}{{deal.EstimatedDealValue}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Commission Split to Proposer: </strong>{{deal.CommissionProposer}}{{deal.CommissionProposer? '%' : ''}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Commission Split to NAI: </strong>{{deal.CommissionNAI}}{{deal.CommissionNAI? '%' : ''}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Final Commission: </strong>{{deal.FinalCommission? '$' : ''}}{{deal.FinalCommission}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Payment Received: </strong>{{deal.PaymentReceived? 'Yes' : 'No'}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Payment Amount: </strong>{{deal.PaymentAmount? '$' : ''}}{{deal.PaymentAmount}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Document Received: </strong>{{deal.DocumentReceived? 'Yes' : 'No'}}
                    </div>
                </div>
                <div class="p-col-12 p-lg-6 p-md-6 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item">
                        <strong>Location: </strong>{{deal.DealLocation}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Value Low: </strong>{{deal.ValueLow? '$' : ''}}{{deal.ValueLow}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Final Deal Value: </strong>{{deal.FinalDealValue? '$' : ''}}{{deal.FinalDealValue}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Commission Split to Receiver: </strong>{{deal.CommissionReceiver}}{{deal.CommissionReceiver? '%' : ''}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Estimated Commission: </strong>{{deal.EstimatedCommission? '$' : ''}}{{deal.EstimatedCommission}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Estimated Close Date: </strong>{{deal.EstimatedCloseDate | convertToDateOnly}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Payment Received Date: </strong>{{deal.PaymentReceivedDate | convertToDateOnly}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Flat Fee: </strong>{{deal.FlatFee? '$' : ''}}{{deal.FlatFee}}
                    </div>
                    <div class="p-d-flex p-jc-between item">
                        <strong>Document Received Date: </strong>{{deal.DocumentReceivedDate | convertToDateOnly}}
                    </div>
                </div>               
            </div>           
        </p-accordionTab>
        <p-accordionTab header="Property Information" [selected]="true">
            <div class="p-grid">
                <div class="p-col-12 p-lg-6 p-md-6 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item"><strong>Property Type: </strong>{{deal.PropertyTypesName}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property Size: </strong>{{deal.EstimatedSize}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property Address: </strong>{{deal.PropertyAddress}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property City: </strong>{{deal.PropertyCity}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property Zip: </strong>{{deal.PropertyZip}}</div>
                </div>
                <div class="p-col-12 p-lg-6 p-md-6 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item"><strong>Unit of Measurement: </strong>{{deal.UnitOfMeasurementTypesName}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Last Update: </strong>{{deal.LastUpdate | convertToDateOnly}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property Address2: </strong>{{deal.PropertyAddress2}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property State: </strong>{{deal.StatesName}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Property Country: </strong>{{deal.CountriesName}}</div>
                </div>              
            </div>          
        </p-accordionTab>
        <p-accordionTab header="Client Information" [selected]="true">
            <div class="p-grid">
                <div class="p-col-12 p-lg-6 p-md-6 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item"><strong>Client Company Name: </strong>{{deal.ClientCoName}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Client Contact Name: </strong>{{deal.ClientContactName}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Client Contact Phone: </strong>{{deal.ClientContactPhone}}</div>
                </div>
                <div class="p-col-12 p-lg-6 p-md-6 widget-topsearchs">
                    <div class="p-d-flex p-jc-between item"><strong>Client Location: </strong>{{deal.ClientCoLocation}}</div>
                    <div class="p-d-flex p-jc-between item"><strong>Client Contact Email: </strong>{{deal.ClientContactEmail}}</div>
                </div>               
            </div>         
        </p-accordionTab>
    </p-accordion>
    </div>
  
</div>
<p-confirmDialog header="Confirmation" icon="ui-icon-warning" width="800"></p-confirmDialog>
